/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { IVisitor } from '../visitors/IVisitor';
import { Node } from './Node';

/**
 * Models a single extension property of a node in the data model.  For example, if the
 * Info node has a property called "x-vendor-zipcode" with a value of "90210", that would
 * result in an instance of this class with appropriate values for "name" and "value".
 * @author eric.wittmann@gmail.com
 * @class
 * @extends Node
 */
export class Extension extends Node {
    public name : string;

    public value : any;

    /**
     * @see io.apicurio.datamodels.core.models.Node#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        visitor.visitExtension(this);
    }

    constructor() {
        super();
        if(this.name===undefined) this.name = null;
        if(this.value===undefined) this.value = null;
    }
}
Extension["__class"] = "io.apicurio.datamodels.core.models.Extension";
Extension["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable"];




